import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import type { TextFieldProps } from '@mui/material/TextField';
import React, { useState } from 'react';

import TextInput from './TextInput';

const PasswordField = React.forwardRef<HTMLDivElement, TextFieldProps>(
  (props, ref) => {
    const { slotProps, ...restProps } = props;

    const [visible, setVisible] = useState(false);

    const handleTogglePasswordVisibility = () => {
      setVisible((current) => !current);
    };

    const handleMouseDownPassword = (event: React.MouseEvent) => {
      event.preventDefault();
    };

    return (
      <TextInput
        autoComplete="new-password"
        {...restProps}
        ref={ref}
        type={visible ? 'text' : 'password'}
        slotProps={{
          ...slotProps,
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  size="small"
                  aria-label="toggle password visibility"
                  onMouseDown={handleMouseDownPassword}
                  onClick={handleTogglePasswordVisibility}
                >
                  {visible ? (
                    <VisibilityIcon sx={{ fontSize: 18 }} color="disabled" />
                  ) : (
                    <VisibilityOffIcon
                      sx={{ fontSize: 18 }}
                      color="disabled"
                    />
                  )}
                </IconButton>
              </InputAdornment>
            ),
            ...(slotProps?.input as Record<string, unknown>),
          },
        }}
      />
    );
  },
);

PasswordField.displayName = 'PasswordField';
export default PasswordField;
